import React from 'react'

import {
  Box,
  Grid,
  Typography,
} from '@mui/material'

const LandingInterested = (props) => {
  return (
    <Grid container spacing={2} p={4} py={8} sx={{ bgcolor: 'white' }}>
      <Grid item xs={12} pb={2}>
        <Typography align='center' color='primary' variant='h3' gutterBottom>
          <b style={{ fontWeight: 900 }}>¿Estás interesado?</b>
        </Typography>
        <Typography align='center' color='#00c08b' variant='h5' gutterBottom>
          <b style={{ fontWeight: 700 }}>Es momento de zarpar</b>
        </Typography>
      </Grid>
      <Grid item xs={12} md={4} align='center'>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              component='img'
              src='/assets/images/step-one.png'
              sx= {{ width: '30%' }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography align='center' color='primary' variant='h6' gutterBottom>
              <b style={{ fontWeight: 900 }}>Contáctanos</b>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={4} align='center'>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              component='img'
              src='/assets/images/step-two.png'
              sx= {{ width: '30%' }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography align='center' color='primary' variant='h6' gutterBottom>
              <b style={{ fontWeight: 900 }}>Comienza a usar LightSpot</b>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={4} align='center'>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              component='img'
              src='/assets/images/step-three.png'
              sx= {{ width: '30%' }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography align='center' color='primary' variant='h6' gutterBottom>
              <b style={{ fontWeight: 900 }}>Mejora tu preceptoría</b>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default LandingInterested